import { Link } from "wouter";
import { ArrowLeft } from "lucide-react";
import { PageContainer } from "../components/layout/PageContainer";
import { EventSubmitForm } from "../components/forms/EventSubmitForm";
import { Button } from "../components/ui/button";

export function SubmitPage() {
  return (
    <PageContainer>
      {/* Back link */}
      <div className="mb-6">
        <Button variant="ghost" size="sm" asChild>
          <Link href="/events">
            <ArrowLeft className="w-4 h-4" />
            Back to Calendar
          </Link>
        </Button>
      </div>

      {/* Header */}
      <header className="mb-8">
        <h1 className="font-display text-3xl text-foreground mb-2">Submit an Event</h1>
        <p className="text-muted-foreground">
          Share a dance event with the community. Your event will be visible immediately.
        </p>
      </header>

      {/* Form card */}
      <div className="bg-card rounded-xl border border-border/50 p-5 sm:p-6">
        <EventSubmitForm />
      </div>
    </PageContainer>
  );
}
